import React from "react";
import { TableCell, TableRow } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ProformaEmployeeCostReportSectionRef } from "../../../models/proforma-employee-cost-report/proforma-employee-cost-report-section-ref";
import { EMPLOYEE_COST_SECTION_TYPES, SELECTED_PERIOD } from "../../../utils/constants/employee-cost-report-constants";
import ExportedProformaEmployeeCostReportPriceToTheClientSection from "./ExportedProformaEmployeeCostReportPriceToClientSection";

interface Props {
  section: ProformaEmployeeCostReportSectionRef;
  selectedPeriod?: SELECTED_PERIOD;
  monthlyView: boolean;
}

const ExportedProformaEmployeeCostReportSection = ({ section, selectedPeriod, monthlyView }: Props) => {
  const theme = useTheme();

  return (
    <>
      {section.type?.type?.id === EMPLOYEE_COST_SECTION_TYPES.Price_to_the_client.id ? (
        <ExportedProformaEmployeeCostReportPriceToTheClientSection
          section={section}
          selectedPeriod={selectedPeriod}
          monthlyView={monthlyView}
        />
      ) : (
        <>
          <TableRow
            style={{
              backgroundColor: section.type?.legislationEmployeeCostSectionGroup?.highlightBackground
                ? theme.palette.background.paper
                : "transparent",
            }}
          >
            <TableCell style={{ fontWeight: section.type?.isBold ? "bold" : "normal" }}>{section.type?.name}</TableCell>
            <TableCell
              align="center"
              style={{ fontWeight: section.type?.isBold ? "bold" : "normal" }}
            >{`${
              section.manualRate && section.manualRate > 0
                ? section.manualRate + "%"
                : section.systemRate && section.systemRate > 0
                ? section.systemRate + "%"
                : ""
            } 
              `}</TableCell>
            <TableCell
              align="right"
              style={{ fontWeight: section.type?.isBold ? "bold" : "normal" }}
            >
              {monthlyView ? (section.amount / 12).toLocaleCustom() : section.amount.toLocaleCustom() ?? ""}
            </TableCell>
          </TableRow>
        </>
      )}
    </>
  );
};

export default ExportedProformaEmployeeCostReportSection;
